<template>
  <div>
    <component
      :is="step"
      @goto="goto"
    />
  </div>
</template>

<script>
import swal from 'sweetalert2'
import { get } from 'axios'
import Init from './modify/Init'
import Rates from './modify/Rates'
import Rooming from './modify/Rooming'
import Success from './modify/Success'
import Conditions from './modify/Conditions'
import { API_ENDPOINT_BASE } from '@/constans'
import { LOADING, RESERVATIONS, FINANCING } from '@/store/mutations'

export default {
  components: {
    Conditions,
    Init,
    Rates,
    Rooming,
    Success
  },
  data () {
    return {
      step: 'Init'
    }
  },
  methods: {
    goto (step) {
      this.step = step
    }
  },
  beforeRouteLeave (to, from, next) {
    if (this.step !== 'success') {
      swal({
        title: 'Esta seguro?',
        text: 'Se perderan las modificaciones.',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si',
        cancelButtonText: 'Cerrar'
      })
        .then(({ value }) => {
          value ? next() : next(false)
        })
        .catch(e => {
          console.log(e)
        })
    } else {
      this.$store.commit(LOADING, true)
      get(API_ENDPOINT_BASE + '/reservations/' + from.params.id)
        .then(({ data }) => {
          let reservations = [data]
          if (
            this.$store.state.reservations &&
						this.$store.state.reservations.some(
						  reservation => reservation.id == from.params.id
						)
          ) {
            reservations = this.$store.state.reservations.map(reservation =>
              reservation.id == from.params.id
                ? Object.assign(reservation, data)
                : reservation
            )
          }
          this.$store.commit(RESERVATIONS, reservations)
        })
        .catch(error => {
          swal({ html: error.response.data.msg, type: 'error' })
        })
        .finally(() => {
          next()
          this.$store.commit(LOADING, false)
        })
    }
  }
}
</script>
